import { render, staticRenderFns } from "./DataCertificate.vue?vue&type=template&id=64a6fdf8"
import script from "./DataCertificate.vue?vue&type=script&lang=js"
export * from "./DataCertificate.vue?vue&type=script&lang=js"
import style0 from "./DataCertificate.vue?vue&type=style&index=0&id=64a6fdf8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports